// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-sidebar{bottom:4px;top:68px}@media (max-width:992px){.user-sidebar{bottom:0;height:auto;top:auto;width:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
